import { Skeleton } from "@/components/ui/skeleton";

import { TicketHistorySkeleton } from "./ticket-history-skeleton";

/** Loading placeholder mirroring PassengerTable — reservation summary, tickets, passengers. */
export function PassengerTableSkeleton() {
  return (
    <div className="bg-white px-6 py-5 text-left">
      <Skeleton className="h-6 w-40" />
      <Skeleton className="mt-2 h-4 w-80" />

      {/* Reservation summary */}
      <div className="mt-4">
        <div className="rounded-md border bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:py-5">
          <div className="px-4">
            <Skeleton className="h-4 w-28" />
          </div>
          <div className="mt-1 space-y-2 px-4 sm:col-span-2 sm:mt-0">
            <Skeleton className="h-4 w-56" />
            <Skeleton className="h-4 w-72" />
            <Skeleton className="h-4 w-64" />
          </div>
        </div>
      </div>

      {/* Billets électroniques */}
      <div className="mt-12 px-2">
        <Skeleton className="h-5 w-44" />
        <Skeleton className="mt-2 h-4 w-72" />
        <div className="w-full py-2">
          <TicketHistorySkeleton />
        </div>
      </div>

      {/* Réservation détaillée trigger */}
      <div className="-mx-6">
        <div className="w-full py-4">
          <div className="mx-auto w-full rounded-2xl bg-white p-2">
            <Skeleton className="h-10 w-full rounded-lg" />
          </div>
        </div>
      </div>

      {/* Passengers table */}
      <div className="-mx-6">
        <div className="overflow-hidden rounded-lg border-y border-gray-200 shadow">
          <div className="flex items-center justify-between bg-stone-100 px-6 py-3">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-3 w-24" />
          </div>
          <div className="divide-y divide-gray-200 bg-white">
            {["pax-1", "pax-2", "pax-3"].map((id) => (
              <div key={id} className="flex items-center justify-between px-6 py-4">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-40" />
                </div>
                <div className="space-y-2">
                  <Skeleton className="h-4 w-28" />
                  <Skeleton className="h-3 w-36" />
                </div>
                <Skeleton className="h-4 w-4 rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
